export const fromS3 = (assetPath: string) => {
  const isCiBuild = import.meta.env.VITE_VERSION_HASH.length === 40;
  if (isCiBuild) {
    return `/unversioned/${assetPath}`;
  }
  return `/${assetPath}`;
};
